import Link from 'next/link'
import classes from '../../../styles/track_order.module.css'
import { formatDate, getWebsiteID } from "../../../lib/common-functions"
import Snackbar from '@material-ui/core/Snackbar';
import React, { useState } from "react";
import FormLoader from "../../../components/ui/FormLoader"
import { useCookies } from "react-cookie"
import Head from 'next/head'
import { getTrackOrderData } from '../../../lib/magento-api'
import motif1 from '~/public/images/motif1.inline.svg';
import { useIsMobile } from '/lib/hooks/useIsMobile';
import { useForm } from "react-hook-form";
 
import { useNotifyModal } from "/lib/hooks/useNotifyModal";
import dynamic from "next/dynamic";
const NotifyModal = dynamic(() => import('/components/NotifyModal'))

export default function TrackOrder() {
	const isMobileDevice = useIsMobile();
	const [cookie, setCookie] = useCookies(["store"])
	const [showLoader, setShowLoader] = useState(false);
	const [orderData, setOrderData] = useState([]);
	let website_id = getWebsiteID(cookie);
	const [error, setError] = useState("");
	const [state, setState] = useState({
		open: true,
		vertical: 'top',
		horizontal: 'center',
	});
	const { vertical, horizontal, open } = state;
	const currency = (website_id == 1) ? 'INR' : 'USD';

	 
	const { showNotifyModal, handleModalClose } = useNotifyModal();

	const handleSnackClose = () => {
		setState({ ...state, open: false });
	};

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		defaultValues: {
			order_id: '',
			email: ''
		}
	});

	const onSubmit = data => {
		setShowLoader(true)

		const response = async () => {
			try {
				const tmp = await getTrackOrderData(website_id, data?.email, data?.order_id);
				if (tmp?.message && tmp?.success == false) {
					setShowLoader(false)
					setError(tmp.message);
					setState({ ...state, open: true });
					setOrderData([])
				} else {
					setShowLoader(false)
					setOrderData((tmp?.success == true) ? tmp.data : [])

				}
			} catch (error) {
				console.log('error', error);
				setShowLoader(false)
			}
		};
		response();
	};

	return (
		<div className="container">
			<Head>
				<title>Orders and Returns</title>
				<meta name="title" content="Orders and Returns" />
				<meta name="description" content="Kama Ayurveda" />
				<meta name="keywords" content="ayurveda online shop,ayurvedic beauty products,ayurvedic cosmetic products,ayurvedic hair products,ayurvedic online store,ayurvedic products,ayurveda for skin" />
				<meta property="og:title" content="Orders and Returns" />
				<meta property="og:description" content="Kama Ayurveda" />
				<meta property="og:image" content={process.env.NEXTAUTH_URL + "/images/Kama-Brand-Logo.png"} />
				<meta property="twitter:description" content="Kama Ayurveda" />
				<meta property="twitter:title" content="Orders and Returns" />
			</Head>
			<FormLoader show={showLoader} />
			{showNotifyModal ? <NotifyModal
				handleModalClose={handleModalClose}
				className='notifyContent'
				isOpen={showNotifyModal}
			/> : null}
			{error && (
				<Snackbar
					autoHideDuration={1500}
					anchorOrigin={{ vertical, horizontal }}
					open={open}
					onClose={handleSnackClose}
					message={error}
					key={vertical + horizontal}
				/>
			)}
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className={classes["new-address-sec"]}>
					<h2>Track Order</h2>
					<p>Please Enter Below Information</p>
					<div className={classes["input_colm"]}>
						<label htmlFor="order_id">Order ID <sup>*</sup></label>
						<input {...register("order_id", {
							required: {
								value: true,
								message: 'Order ID is required'
							}
						})}
							name="order_id"
							type="text"
						/>
						{errors?.order_id && (
							<div className="comm-error">
								{errors?.order_id.message}
							</div>
						)}
					</div>
					<div className={classes["input_colm"]}>
						<label htmlFor="email">Email <sup>*</sup></label>
						<input {...register("email", {
							required: {
								value: true,
								message: 'Email is required'
							},
							pattern: {
								value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
								message: 'Enter a valid email'
							}

						})}
							name="email"
							type="email"
						/>
						{errors?.email && (
							<div className="comm-error">
								{errors?.email.message}
							</div>
						)}
					</div>
				</div>
				<div className={classes["cart-checkout-submit-btn"]}>
					<button type="submit"> Continue</button>
				</div>
			</form>

			{
				(orderData?.order_id) ? (
					<>
						<div className={classes["mobile-returns-refunds"]}>
							<div className={classes["payment-gateway-desktop"]}>
								<div className={classes["payment-gateway-sec1"]}>
									<h2>
										Order # {orderData.order_id}
									</h2>
								</div>
								<div className={classes["order-status-row"]}>
									<p>
										<span className={classes["order-status"]}>{orderData.status} </span>
										<span className="label">Order Date:</span>
										<span>{formatDate(orderData.order_date.replace(" ", "T"))}</span>
									</p>
								</div>
								<div className={classes["order_track_btn"]}>
									{(orderData?.shipment?.track_number) ? (
										<ul>
											<li>
												<Link href={(orderData?.shipment?.track_number) ? `https://kamaayurveda-tracking.unicommerce.com/order/?id=${orderData.shipment.track_number}` : ''}>Track Shipment</Link>
											</li>
										</ul>
									) : null
									}

								</div>
							</div>
							<h3>Items Ordered</h3>
							<div className={`table-responsive ${classes["table-responsive}"]}`}>
								<table>
									<thead>
										<tr><th>Product Name</th>
											<th>MRP</th>
											<th>Qty</th>
											<th>Subtotal</th></tr>
									</thead>
									<tbody>
										{
											orderData?.product.map(function (element, index) {
												return (
													<tr key={index}>
														<td>{element.product_name}</td>
														<td>{currency + " " + element.price}</td>
														<td><
															ul className={classes["items-qty"]}>
															<li className={classes["item"]}>
																<span className={classes["title"]}>Ordered :</span>
																<span className={classes["content"]}>{parseInt(element.qty)}</span>
															</li>
														</ul>
														</td>
														<td>{currency + " " + parseFloat(element.row_total).toFixed(2)}</td>
													</tr>
												)
											})
										}


										<tr>
											<td colSpan="3">Subtotal</td><td>{currency + " " + parseFloat(orderData.subtotal).toFixed(2)}</td>
										</tr>
										<tr>
											<td colSpan="3">Shipping & Handling</td><td>{currency + " " + parseFloat(orderData.shipping_amount).toFixed(2)}</td>
										</tr>
										<tr className={classes["grand-total-colm"]}>
											<td colSpan="3">Grand Total</td>
											<td>{currency + " " + parseFloat(orderData.grand_total).toFixed(2)}</td>
										</tr>
									</tbody>
								</table></div>
							<h3>Order Information</h3>
							<div className={classes["mobile_contact_sec3"]}>
								<ul className="row">
									{
										(orderData.shipping) ? (
											<li className="col-12 col-md-4">
												<div className={classes["orderdetailstrack_row"]}>
													<h5>Shipping Address</h5>
													<p>{orderData.shipping.firstname + " " + orderData.shipping.lastname},</p>
													<p>{((orderData.shipping.street) ? orderData.shipping.street + ", " : "")}</p>
													<p>
														{((orderData.shipping.city) ? orderData.shipping.city + ", " : "")}
														{((orderData.shipping.region) ? orderData.shipping.region + ", " : "")}
														{((orderData.shipping.country) ? orderData.shipping.country + ", " : "")}
														{((orderData.shipping.postcode) ? orderData.shipping.postcode + ", " : "")}
													</p>
													<p>Phone: {orderData.shipping.telephone}</p>
												</div>
											</li>
										) : null
									}
									{
										(orderData.billing) ? (
											<li className="col-12 col-md-4">
												<div className={classes["orderdetailstrack_row"]}>
													<h5>Billing Address</h5>
													<p>{orderData.billing.firstname + " " + orderData.billing.lastname},</p>
													<p>{((orderData.billing.street) ? orderData.billing.street + ", " : "")}</p>
													<p>
														{((orderData.billing.city) ? orderData.billing.city + ", " : "")}
														{((orderData.billing.region) ? orderData.billing.region + ", " : "")}
														{((orderData.billing.country) ? orderData.billing.country + ", " : "")}
														{((orderData.billing.postcode) ? orderData.billing.postcode + ", " : "")}
													</p>
													<p>Phone: {orderData.billing.telephone}</p>
												</div>
											</li>
										) : null
									}

									<li className="col-12 col-md-4">
										<div className={classes["orderdetailstrack_row"]}>
											<h5>Payment Method</h5>
											<p>{orderData.payment_method}</p>
										</div>
									</li>
								</ul>
							</div>

						</div>

						{isMobileDevice &&
							<div className={classes["cart-checkout-btn"]}>
								<div className="container">
									{(orderData?.shipment?.track_number) ? (
										<ul>
											<li><Link href={(orderData?.shipment?.track_number) ? `https://kamaayurveda-tracking.unicommerce.com/order/?id=${orderData.shipment.track_number}` : ''}>Track Shipment</Link></li>
										</ul>
									) : null
									}
								</div>
							</div>}
					</>
				) : null
			}
		</div>
	);
}
